import { BaseDataModel } from "@domain/BaseDataModel";
import { TeamStatusOption } from "@rogoag/airtable";

export class TeamMember extends BaseDataModel {
	name!: string;
	missionControlUsername!: string;
	appUserId!: number;
	password?: string;
	status!: TeamStatusOption;
	phoneNumber!: string;
}
